import { render, staticRenderFns } from "./PayManagement.vue?vue&type=template&id=2b3e8a89&scoped=true"
import script from "./PayManagement.vue?vue&type=script&lang=ts"
export * from "./PayManagement.vue?vue&type=script&lang=ts"
import style0 from "./PayManagement.vue?vue&type=style&index=0&id=2b3e8a89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3e8a89",
  null
  
)

export default component.exports